import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationRowSpacingMin,
    CalibrationRowSpacingMax
} from 'services/equipmentSets/types';
import {
    makeSelectCalibrationRowSpacingMin,
    makeSelectCalibrationRowSpacingMax
} from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    rowSpacingMin: CalibrationRowSpacingMin;
    rowSpacingMax: CalibrationRowSpacingMax;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsRowWidthListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { rowSpacingMin, rowSpacingMax } = this.props;

        return (
            <ListItem
                description="Row width range"
                value={`${rowSpacingMin}m - ${rowSpacingMax}m`}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    rowSpacingMin: makeSelectCalibrationRowSpacingMin(),
    rowSpacingMax: makeSelectCalibrationRowSpacingMax()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsRowWidthListItemComponent
);
